// v1 is fixed at five by five, matching the backend validator.
export const LIKELIHOOD_LEVELS = 5;

export const SEVERITY_LEVELS = 5;

// Matched by key, not by field role: the store's FieldType projection drops roles, and
// EntityFieldRoles carries no member for any of them. The keys are a fixed contract, seeded by
// migration and not removable.
export const INITIAL_RISK_FIELD_KEY = 'risks__initialRisk';

export const RESIDUAL_RISK_FIELD_KEY = 'risks__residualRisk';

export const TARGET_RISK_FIELD_KEY = 'risks__targetRisk';
